module.exports = {
      id: "google-plain-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#google-plain-color",
      toString: function () {
        return this.url;
      }
    }